import { faqs } from '../../../../data/faqs';
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'ionic-ui';

export default function FAQ() {
  const [seeAll, setSeeAll] = React.useState(false);

  return (
    <div className="rounded-lg p-6 border bg-background dark:bg-background-accent">
      <h3 className="font-semibold text-lg mb-2 text-text-dark-high dark:text-text-light-high">
        Frequently asked questions
      </h3>
      <p className="text-sm mb-4 text-text-dark-low dark:text-text-light-low">
        Information at your fingertips
      </p>
      <div className={`${seeAll ? 'h-auto' : 'h-56'} overflow-hidden`}>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((q, i) => (
            <AccordionItem
              value={`faq-${i}`}
              key={`faq-${i}`}
              className="border rounded py-1 px-4"
            >
              <AccordionTrigger
                className="AccordionItem border-0"
                chevronType="special_1"
                value={`faq-item-${i}`}
              >
                <p className="text-text-dark-high dark:text-text-light-high text-wrap">
                  {q.question}
                </p>
              </AccordionTrigger>
              <AccordionContent>
                <p className="mt-2 text-sm text-text-dark-medium dark:text-text-light-medium">
                  {q.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <div
        onClick={() => setSeeAll(!seeAll)}
        className="relative text-center mt-2"
      >
        <p className="font-bold cursor-pointer text-blue-500 text-sm pt-4">
          {!seeAll ? 'See all' : 'See less'}
        </p>
        <div className="absolute -top-8 left-0 w-full h-8 bg-gradient-to-t dark:from-background-accent from-background to-transparent pointer-events-none"></div>
      </div>
    </div>
  );
}
